import Button from 'components/ui/Button';
import styled from 'styled-components/macro';
import { grey50 } from 'variables/colors';

export const Page = styled.div`
  display: flex;
  height: 100%;
`;

export const LeftContent = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 50%;
  height: 100%;
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 24em;
  height: 100%;
`;

export const LoginButton = styled(Button)`
  margin-top: 1.5em;
`;

export const FormTitle = styled.h1`
  margin-bottom: 1.5em;
`;

export const Logo = styled.img`
  position: absolute;
  top: 5em;
  left: 0;
  width: 14em;
`;

export const Image = styled.img`
  width: 50%;
  object-fit: cover;
`;

export const Disclaimer = styled.p`
  position: absolute;
  bottom: 5em;
  left: 0;
  color: ${grey50};
  font-size: 0.625em;
`;
